<template>
  <Transition name="fade" mode="out-in">
    <template v-if="isOpen" key="wrapper">
      <Transition name="fade" mode="out-in">
        <AccountMenu v-if="isAuth && step === 0"  key="account-menu"/>
        <ModalLayout v-else-if="!isAuth || isAuth && step !== 0" key="modal-layout"/>
      </Transition>
    </template>
  </Transition>
  <Transition name="slide-fade">
    <SaveMessage v-if="isSaved" />
  </Transition>
</template>

<script>
import ModalLayout from "@/components/ModalLayout.vue";
import AccountMenu from "@/components/parts/account/AccountMenu.vue";
import {sendRequests} from "@/mixins/sendRequests";
import {userData} from "@/mixins/userData";
import SaveMessage from "@/components/elements/SaveMessage.vue";
export default {
  name: "AppBlock",
  components: {
    SaveMessage,
    AccountMenu,
    ModalLayout
  },
  mixins: [sendRequests, userData],
  computed: {
    isAuth() {
      return this.context.isAuth ?? false;
    },
    isOpen() {
      return this.context.isOpen ?? false;
    },
    step() {
      return this.context.step ?? 0;
    },
    isSaved() {
      return this.context.isSaved ?? false;
    },
  },
  watch: {
    'context.isAuth'() {
      this.changeLoginBtn();
    },
    'userData': {
      handler() {
        this.changeLoginBtn();
      },
      deep: true
    }
  },
  methods: {
    toggleOpen() {
      if (this.updateContext) {
        this.updateContext('isOpen', !this.isOpen);
      }
    },
    deletePreloader() {
      const preloader = document.querySelector('.cbg-preloader');
      if (preloader) {
        preloader.classList.add('hidden');
        setTimeout(() => {
          preloader.remove();
        }, 500);
      }
    },
    checkUrl() {
      const urlParams = new URLSearchParams(window.location.search);

      let codeType = urlParams.get('action') || null;

      if (codeType !== 'verify' && codeType !== 'reset-password') {
        return;
      }

      const handleResetCode = (code) => {
        this.updateContext('step', 3);
        this.updateContext('isOpen', true);
        this.updateContext('changeToken', code);
      };

      if (codeType === 'reset-password' && urlParams.has('code')) {
        const resetCode = urlParams.get('code');
        handleResetCode(resetCode);
      }

      if (codeType === 'verify' && urlParams.has('code')) {
        const verifyCode = urlParams.get('code');
        this.verifyUserRequest(verifyCode);
      }

      urlParams.delete('code');
      urlParams.delete('action');

      const newUrl = `${window.location.origin}${urlParams.toString() ? '?' + urlParams.toString() : ''}`;
      window.history.replaceState({}, document.title, newUrl);

      setTimeout(() => {
        this.deletePreloader();
      }, 1000);
    },

    checkUrlForRegister() {
      if (/^\/register\/?$/.test(window.location.pathname)) {
        this.updateContext('step', 0);
        this.updateContext('isOpen', true);

        setTimeout(() => {
          this.deletePreloader();
        }, 1000);
      }
    },

    async checkProviderAuthorize() {
      const url = new URL(window.location.href);
      const authorizeParam = url.searchParams.get('authorize');

      if (!authorizeParam) {
        return;
      }

      const params = url.searchParams;
      const provider = authorizeParam;
      const code = params.get('code');

      await this.loginViaProviderRequest(code, provider);

      const baseUrl = url.origin + url.pathname + url.hash;
      window.history.replaceState({}, document.title, baseUrl);

      setTimeout(() => {
        this.deletePreloader();
      }, 1000);
    },

    checkOffsets() {
      const buttonContainer = this.loginBtn?.closest('.top-panel__container');
      const offset = buttonContainer ? buttonContainer.offsetLeft : '32';
      document.documentElement.style.setProperty('--header-offset', `${offset}px`);
    },
    changeLoginBtn() {
      if (!this.loginBtn) {
        return;
      }

      if (this.context.isAuth) {
        this.loginBtn.classList.add('top-panel__account_auth');
        this.loginBtn.innerHTML = !this.userData.avatar ? `<span class="top-panel__account-default">${this.nameLetter}</span>` : this.loginBtn.innerHTML = `<img class="top-panel__account-img" src="${this.userData.avatar}" alt="User photo">`;
      } else {
        this.loginBtn.classList.remove('top-panel__account_auth');
        this.loginBtn.innerHTML = `<svg class="top-panel__account-img"><use xlink:href="#user"></use></svg>`
      }
    },

    checkButtons() {
      this.allLoginBtns = document.querySelectorAll('[data-id="login-btn"]');
      this.allMenuBtns = document.querySelectorAll('[data-id="account-menu-btn"]');
      this.allLogoutBtns = document.querySelectorAll('[data-id="logout-btn"]');

      this.allLoginBtns.length && this.allLoginBtns.forEach((btn) => {
        btn.addEventListener('click', this.toggleOpen);
      })

      this.allMenuBtns.length && this.allMenuBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (this.updateContext) {
            this.updateContext('isOpen', true);
            this.updateContext('step', 1);
          }
        });
      })

      this.allLogoutBtns.length && this.allLogoutBtns.forEach((btn) => {
        btn.addEventListener('click', this.logOut);
      })
    }
  },
  async mounted() {
    this.loginBtn = document.getElementById('account-btn');
    this.loginBtn && this.loginBtn.classList.remove('top-panel__account_loading');
    this.checkButtons();

    this.checkOffsets();
    this.checkUrl();
    await this.checkProviderAuthorize();
    this.changeLoginBtn();
    this.checkUrlForRegister();
  },
  beforeDestroy() {
    this.allBtns.length && this.allBtns.forEach((btn) => {
      btn.removeEventListener('click', this.toggleOpen);
    })
  },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to /* .fade-leave-active в <2.1.8 */ {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>
